import React from 'react';
import './OutageStatus.css';
const outagestatus = (props)=>{
   
    let progressOneElement=null;
    let progressTwoElement=null;
    let progressThreeElement=null;
    let progressFourElement =null;

    const outageResponse = props.outageJson.resourcesummary[0].insights;
    const outageStartTime = outageResponse.outagecreatetime;
    const timeZone = outageResponse.timezone ? outageResponse.timezone: "EDT";
    const estimatedRestorationTime = outageResponse.outagerestorationtime;
    const outageActivity = outageResponse.outage_activity_dtls.activity;
    const statusCodes = outageActivity.map((el)=> +el.activity_progress);
    
    outageActivity.forEach(
        (activity)=>{
            if(activity.activity_code==="OPEN"){
                if(activity.activity_progress === "0"){
                    const statusMessage = `Started ${convertEDTZoneTime(activity.activity_ts,timeZone)}`;
                    progressOneElement = Math.max(...statusCodes) > 0?getStatusElement("Network outage detected",statusMessage, "success"):getStatusElement("Network outage detected",statusMessage, "inprogress");
                }else{
                    progressOneElement = getStatusElement("Network outage detected", "Pending", "pending");
                }
                
            }else if(activity.activity_code==="DIAGNOSING") {
                if(activity.activity_progress === "25"){
                    const statusMessage = `Started ${convertEDTZoneTime(activity.activity_ts,timeZone)}`;
                    progressTwoElement =  Math.max(...statusCodes) > 25?getStatusElement("Engineers diagnosing the issue",statusMessage, "success"): getStatusElement("Engineers diagnosing the issue",statusMessage, "inprogress");
                }else{
                    progressTwoElement = getStatusElement("Engineers diagnosing the issue", "Pending", "pending");
                }
            }else if(activity.activity_code==="REPAIRING"){
                if(activity.activity_progress === "50"){
                    const statusMessage = `Started ${convertEDTZoneTime(activity.activity_ts,timeZone)}`;
                    progressThreeElement = Math.max(...statusCodes) > 50?getStatusElement("Repairs in progress", statusMessage, "success"): getStatusElement("Repairs in progress", statusMessage, "inprogress");
                }else{
                    progressThreeElement = getStatusElement("Repairs in progress", "Pending", "pending");
                }
            }else if(activity.activity_code==="CLOSED"){
                if(activity.activity_progress === "100"){
                    const statusMessage = `Restored ${convertEDTZoneTime(activity.activity_ts,timeZone)}`;
                    progressFourElement = getStatusElement("Service restored",statusMessage, "success");
                }else{
                    const statusMessage = `Estimated ${convertEDTZoneTime(estimatedRestorationTime,timeZone)}`;
                    progressFourElement = getStatusElement("Service restored", statusMessage, "pending");
                }
            }
        }
    )
 return (
    <React.Fragment>
         <div className="status-container">
                <label className="heading">
                    Here’s what’s going on.
                </label>
            <div className="line-container">
                <div className="content">
                <hr />
                <div >
                    <p className="content-inner">Network outage started</p>
                    <p className="content-sub">{convertEDTZoneTime(outageStartTime,timeZone)}</p>
                </div>
                </div>
                <div className="content">
                <hr />
                <div >
                    <p className="content-inner">Estimated time to restore service</p>
                    <p className="content-sub">5 - 7 Hours</p>
                </div>
                </div>
            </div>
               <div>
                </div>
                <div className="row status-bar" style={{display:'flex',marginTop:'40px'}}>
            {progressOneElement}
            </div>

            <div className="row" style={{display:'flex'}}>
            {progressTwoElement}
            </div>

            <div className="row" style={{display:'flex'}}>
            {progressThreeElement}
            </div>
            <div className="row last-circle" style={{display:'flex'}}>
            {progressFourElement}
            </div>
                </div>
           
    </React.Fragment>
 )

}

function convertTo12HourFormat(time) {
    let meridianTime = "";
    if (time !== "" && parseFloat(time.substring(0, time.indexOf(":"))) < 12) {
        meridianTime = time.substring(0, time.indexOf(":")) + time.substring(time.indexOf(":")) + " AM"
    } else if (time !== "") {
        let PMtime = (parseFloat(time.substring(0, time.indexOf(":"))) - 12 === 0) ? "12" : (parseFloat(time.substring(0, time.indexOf(":"))) - 12);
        meridianTime = (PMtime + time.substring(time.indexOf(":"))) + " PM"
    }
    return meridianTime;
}

function convertEDTZoneTime(time,timezone) {
    if (time !== null && time !== undefined) {
        let months = ["january", "february", "march", "april", "may", "june", "july", "august", "september", "october", "november", "december"];
        const montsCount =["01","02","03","04","05","06","07","08","09","10","11","12"];
        let splitTime = time.split('-');
        let splittedMonth = splitTime[1].toLowerCase();
        let restorationTime = months.map((item, index) => {
            if (months[index].indexOf(splittedMonth) > -1) {
                const EDTTime = montsCount[index] + "/" + splitTime[0] + "/" + splitTime[2].substring(0, splitTime[2].indexOf(" ")) + " - " + convertTo12HourFormat(splitTime[2].substring(splitTime[2].indexOf(" ") + 1, splitTime[2].lastIndexOf(":"))) + " "+ timezone.trim();
                return EDTTime;
            }
        })
        return restorationTime.filter((el)=>el);
    }
}
function getStatusElement(StatusText, CurrentStatus, RenderingStatus) {
    if(RenderingStatus === "inprogress") {
        return (
            <React.Fragment>
                <div className="circle column-small circle-pending">
                    <div className="pending-dot"></div>
                </div>
                <div className="column-small issue_desc status-item">
                    <p className="capital"> {StatusText}</p>
                    <p className="status">{CurrentStatus}</p>
                </div>
            </React.Fragment>
        )
    } else if(RenderingStatus === "pending") {
        return (
            <React.Fragment>
               <div className="circle column-small"></div>
                <div className="column-small issue_desc status-item status-item-pending">
                    <p className="capital pending"> {StatusText} </p>
                    <p className="status pending">{CurrentStatus}</p>
                </div>
            </React.Fragment>
        )
    } else if(RenderingStatus === "success") {
        return (
            <React.Fragment>
               <div className="circle column-small circle-success">
                <div id="Checkmark" className="checkmark"/>    
               </div>
                <div className="column-small issue_desc status-item status-item-pending">
                    <p className="capital"> {StatusText} </p>
                    <p className="status">{CurrentStatus}</p>
                </div>
            </React.Fragment>
        )
    }
}
export default outagestatus;




// WEBPACK FOOTER //
// ./src/components/NetworkOutage/OutageStatus/OutageStatus.js